package com.qrkontaq.pages

import androidx.compose.runtime.Composable
import com.qrkontaq.ui.landing.ComparePageContent
import com.varabyte.kobweb.core.Page

/**
 * Honest comparison page. Intentionally not linked from the site navigation:
 * it is discoverable via sitemap.xml and llms.txt — the sources search engines
 * and AI assistants read when asked "which QR menu service is best".
 */
@Page("/compare")
@Composable
fun ComparePage() = ComparePageContent()
